<template>
    <FooterButton noPadding
                  class="promo-button">
        <div ref="promoButtonRef"
             class="promo-button__content"
             :aria-label="getTrans('header.notifications', 'Notifications')"
             @click="menuStore.isNotificationsModalOpen = true">
            <i class="fa-solid fa-grid" />
            <div class="dot-wrapper">
                <div class="dot" />
            </div>
        </div>
    </FooterButton>
    <Teleport to="body">
        <Transition name="modal-fade">
            <MobileNotifications v-if="menuStore.isNotificationsModalOpen && isMobileOrTablet"
                                 :notifications="menuStore.promoNotifications"
                                 :closeNotificationFunction="() => menuStore.isNotificationsModalOpen = false" />
        </Transition>
    </Teleport>
</template>

<script setup lang="ts">
    import { h, ref, watchEffect } from 'vue';
    import FooterButton from '../../components/FooterButton.vue';
    import useTippyPopup from '../../../../composables/useTippyPopup';
    import DesktopNotificationsTippy from '../../../../quests/dashboard/navigation/desktop/DesktopNotificationsTippy.vue';
    import { useDeviceSize } from '@/js/composables/useDeviceSize';
    import { useMenuStore } from '@/js/store/menu/MenuStore';
    import MobileNotifications from '../../../../quests/dashboard/navigation/mobile/MobileNotifications.vue';
    import { getTrans } from '@/js/helpers/getTrans';

    const menuStore = useMenuStore();

    const { isMobileOrTablet } = useDeviceSize();

    const promoButtonRef = ref(null);

    const { disable, enable } = useTippyPopup(promoButtonRef, {
        content: h(DesktopNotificationsTippy, {
            notifications: menuStore.promoNotifications,
            closeTippy: () => {},
        }),
        placement: 'top',
        interactive: true,
        trigger: 'click',
        theme: 'base',
    });

    watchEffect(() => {
        if (isMobileOrTablet.value) {
            disable();
        } else {
            enable();
        }
    });
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 300ms ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
    opacity: 0;
}

.promo-button {
    position: relative;
    padding: 8px;

    &__content {
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: center;
    }

    .dot-wrapper {
        position: absolute;
        top: calc(50% - 7px);
        right: calc(50% - 7px);
        width: 9px;
        height: 9px;
        transform: translate(50%, -50%);

        .dot {
            width: 9px;
            height: 9px;
            border-radius: 5px;
            background-color: legacyVariables.$down-color;
            pointer-events: none;

            &::after {
                position: absolute;
                width: 15px;
                height: 15px;
                border-radius: 8px;
                margin: auto;
                animation: pulse-me 1.7s linear infinite;
                background-color: legacyVariables.$down-color;
                content: "";
                inset: 0 0 0 -3px;
                transform: scale(0.4);
                transform-origin: center center;
            }
        }
    }

}
</style>
